import { Modal } from '@eika/modal';

const EikaModal = Modal;

export default EikaModal;
